import { gql } from '@apollo/client'

import { TotalOfItems, Transfer } from './types'

// Transfers Subscription

export type SubscriptionTransfers = {
  transfers: Transfer[]
}

export const SUB_TRANSFERS = gql`
  subscription SubTransfers($where: transfer_bool_exp!, $limit: Int) {
    transfers: transfer(
      where: $where
      limit: $limit
      order_by: [{ timestamp: desc }, { id: asc }]
    ) {
      from
      to
      amount
      timestamp
      transferType: transfer_type
      txnHash: txn_hash
      id
      blockNumber: block_number
      eventIndex: event_index
      status
      token {
        id
        nativeId: native_id
        creator: creator_id
        uri
        amount
        metadata
        createdAt: created_at
        createdAtBlock: created_at_block
        collection {
          id
          name
          symbol
          decimals
          collectionType: collection_type
          createdAt: created_at
          createdAtBlock: created_at_block
          creator: creator_id
        }
      }
    }
  }
`

// Transfers Query

export type GetTransfers = TotalOfItems & {
  transfers: Transfer[]
}
export const QUERY_GET_TRANSFERS = gql`
  query GetTransfers(
    $where: transfer_bool_exp!
    $limit: Int
    $offset: Int
    $order: order_by = desc
  ) {
    transfers: transfer(
      where: $where
      limit: $limit
      offset: $offset
      order_by: [{ timestamp: $order }, { id: asc }]
    ) {
      from
      to
      amount
      timestamp
      transferType: transfer_type
      txnHash: txn_hash
      id
      blockNumber: block_number
      eventIndex: event_index
      status
      token {
        id
        nativeId: native_id
        creator: creator_id
        uri
        amount
        metadata
        createdAt: created_at
        createdAtBlock: created_at_block
        collection {
          id
          name
          symbol
          decimals
          collectionType: collection_type
          createdAt: created_at
          createdAtBlock: created_at_block
          creator: creator_id
        }
      }
    }
    total: transfer_aggregate(where: $where) {
      agg: aggregate {
        count
      }
    }
  }
`
